import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  UIButtonComponent,
  UIToggleSwitchComponent,
  UITypographyDirective,
  UIComponentSizeDirective,
  UIDividerComponent
} from '@bannerflow/ui';
import { NotificationService } from '../../../../services/notification.service';

@Component({
  imports: [
    UIButtonComponent,
    UIToggleSwitchComponent,
    UITypographyDirective,
    UIComponentSizeDirective,
    UIDividerComponent
  ],
  selector: 'ns-popover-header',
  templateUrl: './popover-header.component.html',
  styleUrl: './popover-header.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PopoverHeaderComponent {
  private notificationService = inject(NotificationService);

  isShowingAll = computed(() => this.computeIsShowingAll());
  hasUnreadNotifications = this.notificationService.hasUnreadNotifications;

  markAllAsRead(): void {
    this.notificationService.markAllAsRead();
  }

  setUnreadFilter(checked: boolean): void {
    if (checked) {
      this.notificationService.setFilter('showUnread');
    } else {
      this.notificationService.setFilter('showAll');
    }
  }

  private computeIsShowingAll(): boolean {
    const currentFilter = this.notificationService.currentFilter();
    return currentFilter === 'showAll';
  }
}
